import React from "react";
import { Link } from "react-router-dom";

function EnjoyTheRide() {
  document.title = "SimWealth";
  return (
    <>
      <div className="bg bg-enjoy-the-ride">
      <div data-aos="fade-rigth" className="container d-flex flex-column align-items-end justify-content-end vh-100 w-100">
            <div className="row d-flex justify-content-center align-items-end my-auto text-center w-35">
                <div className="bg-white rounded-border py-3 border border-4 border-dark">
                    <div className="col-12 heading-font mb-3">
                        <div type="button" className="btn btn-warning rounded-pill w-100 py-3 fs-4">Enjoy The Ride</div>
                    </div>
                    <p>If you are worried about numbers or advanced concepts, don’t be!</p>
                    <p>This interactive simulation is meant to be simple, fun, and most importantly, eye-opening.</p>
                    <p>Our objective is to make you AWARE of the truth - the first big step towards making a change in your life.</p>
                    <p>Now sit back and enjoy the ride. You are about to experience a mind-bending simulation.</p>

                    <Link to={"/coffee-rules"} className="threeDButton btn fw-bold  w-75  ">
                        I’m Ready
                    </Link>
                </div>
            </div>
        </div>
      </div>
    </>
  );
}

export default EnjoyTheRide;
